import { Component, ElementRef, inject, Input, ViewChild } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { PopupLogoutComponent } from '../../../../shared/components/popup-logout/popup-logout.component';
import { UserData } from '../../models/user-data';
import { UpperCasePipe } from '@angular/common';
import { UserService } from '../../../../core/services/user.service';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-profile-menu',
  imports: [
    MatMenuModule,
    MatButtonModule,
    RouterLink,
    TranslateModule,
    PopupLogoutComponent,
    UpperCasePipe,
  ],
  templateUrl: './profile-menu.component.html',
  styles: `

  ::ng-deep .profile-menu-button.mat-mdc-button .mdc-button__label{
    background: #FFFFFF8C;
    padding: 7px 16px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    gap: 12px;
    cursor: pointer;
  }


  .mat-mdc-menu-item, .mat-mdc-menu-item:visited, .mat-mdc-menu-item:link{
    padding: 0 8px;
  }
::ng-deep .mat-mdc-menu-item-text {
  display: flex;
  align-items: center;
  gap: 12px;
}

::ng-deep .mat-mdc-button:not(:disabled):hover {
  background: transparent;
  border: none !important;
}

::ng-deep .profile-menu-button .mat-mdc-button-persistent-ripple {
  display: none !important;
}

::ng-deep .profile-menu-button .mat-mdc-focus-indicator {
  display: none !important;
}
  `,
})
export class ProfileMenuComponent {
  @ViewChild('profileDropdown') profileDropdown!: ElementRef;

  userService = inject(UserService);

  popupIsOpen = false;
  user: UserData | null = null;
  ngOnInit() {
    this.getUserData();
  }

  getUserData() {
    this.userService.getUser().subscribe((user) => {
      this.user = user;
    });
  }
  openPopupLogout() {
    this.popupIsOpen = true;
  }

  closePopup() {
    this.popupIsOpen = false;
  }
}
